export default __webpack_public_path__ + "static/media/footer-large.5e4ed2b6.png";